
import { Component, Vue, Prop } from 'vue-property-decorator'
import { formatterMoney, formatterPositiveInteger } from '@/utils/util'
import { formatDate } from './../../index'

@Component
class StepLotteryQualification extends Vue {
  @Prop({ default: () => ({}) }) formData!: any
  formatterMoney = formatterMoney
  formatterPositiveInteger = formatterPositiveInteger

  localForm = {
    // 消费满赠
    isConsumeQualified: 1,
    sumCost: '',
    lotteryLimit: '',
    // 积分兑换
    isPointQualified: 0,
    pointExchange: '',
    // 首单满赠
    isFirstQualified: 0,
    firstCost: '',
    firstCostLotteryNum: ''
  }

  isConsumeQualifiedDisabled = true

  get statisticsTimeText() {
    const { statisticsStartTime = '', statisticsEndTime = '' } = this.formData
    return `${formatDate(statisticsStartTime)} - ${formatDate(
      statisticsEndTime
    )}`
  }

  // get estimatedText() {
  //   if (
  //     Date.now() >
  //     dayjs(`${this.formData.statisticsEndTime} 23:59:59`).valueOf()
  //   ) {
  //     return `预计共赠送 100 名客户，合计免费赠送 300 次抽奖机会`
  //   } else {
  //     return '统计时间段尚未结束，无法生成完整统计数据。'
  //   }
  // }

  validator(value, rule) {
    if (rule.required && !value) {
      return false
    }
  }

  created() {
    // 初始化本地数据
    this.localForm = {
      ...this.localForm,
      ...(this.formData || {})
    }
    this.isConsumeQualifiedDisabled = this.localForm.isConsumeQualified == 1
    this.onInputChange()
  }

  // 输入变化
  onInputChange() {
    this.$emit('update:formData', { ...this.localForm })
  }

  // 限制最小值
  limitMinValue(field: string, min: number) {
    const val = Number(this.localForm[field])
    if (val < min) {
      this.localForm[field] = `${min}`
      this.onInputChange()
    }
  }
}
export default StepLotteryQualification
